import { Link } from "react-router-dom";
import { JiraniLogoMark } from "@/components/JiraniLogo";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-black/5 bg-[#2E473B] text-[#F9F7F4]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <JiraniLogoMark className="h-10 w-10 rounded-xl" />
            <div className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>
              Jirani<span className="text-[#F4A261]">.</span>co
            </div>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/75">
            Your friendly neighborhood, together — safer streets, kinder communities, thriving local business.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#F4A261]">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/feed" className="hover:text-[#F4A261]">Community Feed</Link></li>
            <li><Link to="/alerts" className="hover:text-[#F4A261]">Safety Alerts</Link></li>
            <li><Link to="/directory" className="hover:text-[#F4A261]">Service Directory</Link></li>
            <li><Link to="/marketplace" className="hover:text-[#F4A261]">Marketplace</Link></li>
            <li><Link to="/events" className="hover:text-[#F4A261]">Events & Meetings</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#F4A261]">Community</div>
          <ul className="mt-4 space-y-2 text-sm text-white/85">
            <li>Est. Nairobi, 2026</li>
            <li>Made for East African neighborhoods</li>
            <li>Karibu Jirani!</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#F4A261]">Reach us</div>
          <ul className="mt-4 space-y-2 text-sm text-white/85">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> hello@jirani.co</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Kilimani, Nairobi</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-4 py-5 text-xs text-white/60 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <span>© {new Date().getFullYear()} Jirani.co — Building better neighborhoods.</span>
          <span>Karibu jirani · Habari yako</span>
        </div>
      </div>
    </footer>
  );
}
